
import { ClerkProvider } from '@clerk/clerk-react';
import { BrowserRouter } from 'react-router-dom';

// Import Clerk Publishable Key

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Publishable Key')
}

export default function ClerkProviderWithRoutes({children}) {
    return (
        <ClerkProvider
            publishableKey={PUBLISHABLE_KEY}
            appearance={{
                elements: {
                    // Hide the Dashboard button in UserButton dropdown
                    userButtonPopoverActionButton__dashboard: {
                        display: 'none'
                    }
                }
            }}
        >
            <BrowserRouter>{children}</BrowserRouter>
        </ClerkProvider>
    )
}